import { takeLatest, put, all, call } from 'redux-saga/effects';
import { enums } from 'console-kit';

import ConsoleAppActions from '../../App/redux/app-actions';
import RulesetActions from './ruleset-actions';
import RulesetApi from './ruleset-api';

/** Fetches rulesets. */
function* fetchRulesetsHandler() {
  const response = yield call(RulesetApi.fetchRulesets);

  if (response.error) {
    yield put(RulesetActions.fetchRulesetsFailure(response.error));
  } else {
    yield put(RulesetActions.fetchRulesetsSuccess(response));
  }
}

/** Clones a ruleset. */
function* cloneRulesetHandler({ payload: { rulesetId, rulesetName } }) {
  const { error } = yield call(RulesetApi.cloneRuleset, {
    id:   rulesetId,
    name: rulesetName,
  });

  if (error) {
    yield put(RulesetActions.cloneRulesetFailure(error));
  } else {
    yield put(RulesetActions.cloneRulesetSuccess());
    yield put(
      ConsoleAppActions.setAlertMessage({
        messageType: enums.messageTypes.SUCCESS,
        header:      'success',
        byline:      `The ruleset "${rulesetName}" has been cloned`,
      })
    );

    yield put(RulesetActions.fetchRulesets());
  }
}

/** Creates a ruleset. */
function* createRulesetHandler({ payload: { ruleset } }) {
  const { error } = yield call(RulesetApi.createRuleset, ruleset);

  if (error) {
    yield put(RulesetActions.createRulesetFailure(error));
  } else {
    yield put(RulesetActions.createRulesetSuccess(ruleset));
    yield put(
      ConsoleAppActions.setAlertMessage({
        messageType: enums.messageTypes.SUCCESS,
        header:      'success',
        byline:      `The ruleset "${ruleset.name}" has been created`,
      })
    );

    yield put(RulesetActions.fetchRulesets());
  }
}

/** Updates a ruleset. */
function* updateRulesetHandler({ payload: { ruleset } }) {
  const { error } = yield call(RulesetApi.updateRuleset, ruleset);

  if (error) {
    yield put(RulesetActions.updateRulesetFailure(error));
  } else {
    yield put(RulesetActions.updateRulesetSuccess(ruleset));
    yield put(
      ConsoleAppActions.setAlertMessage({
        messageType: enums.messageTypes.SUCCESS,
        header:      'success',
        byline:      `The ruleset "${ruleset.name}" has been updated`,
      })
    );

    yield put(RulesetActions.fetchRulesets());
  }
}

/** Deletes selected ruleset by ID. */
function* deleteRulesetHandler({ payload: id }) {
  const { error, customError } = yield call(RulesetApi.deleteRulesets, [id]);

  if (error) yield put(RulesetActions.deleteRulesetApiFailure(error)); //default API error handle

  if (customError) {
    const customErrorMessage = customError.map((errorEntity) => errorEntity.message).join(', ');

    yield all([
      yield put(
        ConsoleAppActions.setAlertMessage({
          messageType: enums.messageTypes.ERROR,
          header:      'error',
          byline:      customErrorMessage,
        })
      ),
    ]);
  }

  if (error || customError) {
    yield put(RulesetActions.deleteRulesetFailure());
  } else {
    //else the success path
    yield all([
      yield put(RulesetActions.deleteRulesetSuccess(id)),
      yield put(
        ConsoleAppActions.setAlertMessage({
          messageType: enums.messageTypes.SUCCESS,
          header:      'success',
          byline:      'Successfully deleted the ruleset',
        })
      ),
    ]);
  }

  yield put(RulesetActions.fetchRulesets());
}

function* rulesetsSagas() {
  yield all([
    takeLatest(RulesetActions.fetchRulesets.getType(), fetchRulesetsHandler),
    takeLatest(RulesetActions.cloneRuleset.getType(), cloneRulesetHandler),
    takeLatest(RulesetActions.createRuleset.getType(), createRulesetHandler),
    takeLatest(RulesetActions.updateRuleset.getType(), updateRulesetHandler),
    takeLatest(RulesetActions.deleteRuleset.getType(), deleteRulesetHandler),
  ]);
}

export default rulesetsSagas;
